function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import filter from 'lodash/filter';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import has from 'lodash/has';
import map from 'lodash/map';
import { createValidatorRules } from 'helpers/templatedFields';
import Avatar from 'components/Avatar';
import FormContainerAbstract from 'components/FormContainerAbstract';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Select from 'components/Form/Select';
import Button from 'components/Form/Button';
import TemplatedFields from 'components/TemplatedFields';
import templateFieldShape from 'shapes/templateFieldShape';
import App, { AvatarCropModal } from 'modules/App';
import Information from 'modules/Information';
import * as constants from '../../../constants';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import validatorRules from './validatorRules.json';
class InformationForm extends FormContainerAbstract {
    componentDidMount() {
        const staticFieldsTemplate = filter(this.props.organizationTemplate, (fieldTemplate)=>fieldTemplate.name !== 'organizationIdentifier');
        forEach(staticFieldsTemplate, (fieldTemplate)=>this.onAddValidatorRules(createValidatorRules(fieldTemplate)));
    }
    componentDidUpdate(prevProps) {
        if (prevProps.organizationTemplate !== this.props.organizationTemplate) {
            const staticFieldsTemplate = filter(this.props.organizationTemplate, (fieldTemplate)=>fieldTemplate.name !== 'organizationIdentifier');
            forEach(staticFieldsTemplate, (fieldTemplate)=>this.onAddValidatorRules(createValidatorRules(fieldTemplate)));
        }
    }
    onAddValidatorRules(rules) {
        this.validatorRules = _object_spread({}, this.validatorRules, rules);
    }
    onBack() {
        this.props.onBack();
    }
    onSubmitAvatar(image) {
        this.props.onSetFormValue({
            id: 'logo',
            value: image
        });
    }
    get strictProfileTemplate() {
        if (!this.props.organizationTemplate) {
            return [];
        }
        const filterCondition = (fieldTemplate)=>[
                'organizationIdentifier'
            ].includes(fieldTemplate.name);
        return this.props.organizationTemplate.filter(filterCondition);
    }
    get isStateFieldHidden() {
        const stateFieldDefinition = find(this.props.organizationTemplate, {
            name: 'state'
        });
        return !has(stateFieldDefinition, 'isMandatory');
    }
    get isZipCodeFieldHidden() {
        const stateFieldDefinition = find(this.props.organizationTemplate, {
            name: 'zipCode'
        });
        return !has(stateFieldDefinition, 'isMandatory');
    }
    renderActions() {
        const { activeStepIdx, organizationTemplate } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: "row flex-column-reverse flex-sm-row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-12 col-sm-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons[activeStepIdx ? 'back' : 'cancel'],
                        className: "btn--block",
                        onClick: ()=>this.onBack()
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-12 col-sm-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.next,
                        className: "btn--block btn--filled",
                        isDisabled: this.isDisabled || !organizationTemplate.length
                    })
                })
            ]
        });
    }
    renderLanguage() {
        const { languages } = this.props;
        const appLocales = filter(App.constants.APP_LOCALES, (appLocale)=>find(languages, (lang)=>lang.code === appLocale || lang.code === App.constants.APP_LOCALE_LANGUAGES_MAP[appLocale])).map((language)=>({
                value: App.constants.APP_LOCALE_LANGUAGES_MAP[language] || language,
                label: get(find(languages, (lang)=>lang.code === language || lang.code === App.constants.APP_LOCALE_LANGUAGES_MAP[language]), 'nativeName', language)
            }));
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "languageCode",
            labelMessage: messages.labels.language,
            formValues: this.props.formValues,
            children: /*#__PURE__*/ _jsx(Select, {
                optionsFrom: map(appLocales, (appLocale)=>appLocale),
                valueKey: "value",
                labelKey: "label",
                onChange: (input)=>this.props.onSetFormValue(input)
            })
        });
    }
    renderState() {
        if (this.isStateFieldHidden) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "col-6 col-sm-3 mt-6 mt-sm-0",
            children: /*#__PURE__*/ _jsx(FormGroup, {
                id: "state",
                labelMessage: messages.labels.state,
                formValues: this.props.formValues,
                children: /*#__PURE__*/ _jsx(Input, {
                    placeholder: messages.placeholders.state,
                    onChange: this.props.onSetFormValue
                })
            })
        });
    }
    renderZipCode() {
        if (this.isZipCodeFieldHidden) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "col-6 col-sm-3 mt-6 mt-sm-0",
            children: /*#__PURE__*/ _jsx(FormGroup, {
                id: "zipCode",
                labelMessage: messages.labels.zipCode,
                formValues: this.props.formValues,
                children: /*#__PURE__*/ _jsx(Input, {
                    placeholder: messages.placeholders.zipCode,
                    onChange: this.props.onSetFormValue
                })
            })
        });
    }
    renderAddressForm() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "pt-3",
            children: [
                /*#__PURE__*/ _jsx("h5", {
                    className: "text--h5",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.organizationAddress))
                }),
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "street",
                    labelMessage: messages.labels.street,
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(Input, {
                        placeholder: messages.placeholders.street,
                        onChange: this.props.onSetFormValue
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-12 col-sm-6",
                            children: /*#__PURE__*/ _jsx(FormGroup, {
                                id: "city",
                                labelMessage: messages.labels.city,
                                formValues: this.props.formValues,
                                children: /*#__PURE__*/ _jsx(Input, {
                                    placeholder: messages.placeholders.city,
                                    onChange: this.props.onSetFormValue
                                })
                            })
                        }),
                        this.renderZipCode(),
                        this.renderState()
                    ]
                })
            ]
        });
    }
    renderMembershipForm() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "pt-3",
            children: [
                /*#__PURE__*/ _jsx("h5", {
                    className: "text--h5",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.organizationMembershipInfo))
                }),
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "businessEmail",
                    labelMessage: messages.labels.businessEmail,
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(Input, {
                        placeholder: messages.placeholders.businessEmail,
                        onChange: (input)=>this.onSetValue(input)
                    })
                })
            ]
        });
    }
    renderForm() {
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "form-groups pt-5",
                    children: [
                        /*#__PURE__*/ _jsx(FormGroup, {
                            id: "name",
                            labelMessage: messages.labels.name,
                            formValues: this.props.formValues,
                            children: /*#__PURE__*/ _jsx(Input, {
                                placeholder: messages.placeholders.name,
                                onChange: this.props.onSetFormValue
                            })
                        }),
                        this.renderLanguage(),
                        /*#__PURE__*/ _jsx(TemplatedFields, {
                            template: this.strictProfileTemplate,
                            formValues: this.props.formValues,
                            messages: messages,
                            localizationResources: this.props.localizationResources,
                            validatorRules: this.validatorRules,
                            onAddValidatorRules: (rules)=>this.onAddValidatorRules(rules),
                            onSetFormValue: this.props.onSetFormValue,
                            onSetFormValues: this.props.onSetFormValues
                        })
                    ]
                }),
                this.renderAddressForm(),
                this.renderMembershipForm(),
                this.renderActions()
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Avatar, {
                    id: "logo",
                    avatarImg: get(this.props.formValues, 'values.logo'),
                    name: get(this.props.formValues, 'values.name', ''),
                    size: 80,
                    isEditable: true,
                    onSetFormValue: this.props.onSetFormValue,
                    onFormErrors: this.props.onFormErrors
                }),
                this.renderForm(),
                /*#__PURE__*/ _jsx(AvatarCropModal, {
                    adjustHeaderMessage: messages.headers.logoAdjust,
                    uploadHeaderMessage: messages.headers.logoUpload,
                    onImageSubmit: (image)=>this.onSubmitAvatar(image)
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.validatorRules = _object_spread({}, validatorRules);
        const businessEmail = get(props.formValues, 'values.businessEmail');
        if (!businessEmail) {
            props.onSetFormValues({
                businessEmail: props.information.email
            });
        }
    }
}
_define_property(InformationForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    activeStepIdx: PropTypes.number,
    // Implicit props
    organizationTemplate: PropTypes.arrayOf(templateFieldShape),
    information: PropTypes.object,
    languages: PropTypes.arrayOf(App.shapes.language),
    localizationResources: PropTypes.object,
    // Explicit actions
    onSuccess: PropTypes.func,
    onBack: PropTypes.func
}));
const mapStateToProps = (state)=>({
        organizationTemplate: selectors.organizationTemplate(state),
        information: Information.selectors.information(state),
        formValues: App.selectors.formSelector(constants.CREATE_FORM)(state),
        languages: App.selectors.languages(state),
        localizationResources: App.selectors.localizationResources(state)
    });
const mapDispatchToProps = (dispatch, props)=>{
    const formName = constants.CREATE_FORM;
    return {
        onSubmit: (values)=>props.onSuccess(values),
        onResetForm: ()=>dispatch(App.actions.resetForm(formName)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName))
    };
};
const ConnectedInformationForm = connect(mapStateToProps, mapDispatchToProps)(InformationForm);
export default ConnectedInformationForm;
